<template>
  <div class="px-2">
    <div class="font-size-18 fw-semibold">Tên nhóm</div>
    <el-input v-model="groupName" placeholder="Nhập tên nhóm chat" />

    <div class="d-flex mt-2">
      <div class="flex-1">
        <div class="font-size-16 fw-bold">Bạn bè</div>
        <div class="d-flex">
          <el-input class="py-2" v-model="searchKey" @input="searchContact()" placeholder="Tìm kiếm bạn bè" />
          <div class="mx-1" />
        </div>
        <div class="add-group-contact-scr">
          <div v-for="(contact,index) in contactView" :key="index">
            <div class="d-flex py-2">
              <el-checkbox :value="checkSelectedContact(contact.uid)"
                           @change="selectItem(contact)" />
              <el-avatar :size="24" :src="contact.avatar" class="mx-2" />
              <div class="flex-1 font-size-16 text-1-line">{{ contact.displayName }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-1 px-2">
        <div class="font-size-16 fw-bold">Đã chọn ( {{ items.length }} )</div>
        <div class="add-group-con-scr">
          <div v-for="(contact,index) in items" :key="index">
            <div class="d-flex py-2">
              <el-checkbox :value="true" @change="unSelect(contact.id)" />
              <el-avatar :size="24" :src="contact.avatar" class="mx-2" />
              <div class="flex-1 font-size-16 text-1-line">{{ contact.displayName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="divider-custom" />
    <div class="d-flex justify-content-end mt-1">
      <el-button type="danger" size="md" @click="close()">Hủy</el-button>
      <el-button type="primary" size="md" @click="save()">Tạo nhóm</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateGroup",
  props: ["accountId", "userId"],
  data() {
    return {
      groupName: "",
      contactList: [],
      searchKey: "",
      items: [],
      contactView: []
    };
  },
  methods: {
    getMembersId() {
      let items = this.items.map(p => {
        return p.uid;
      });

      return items;
    },
    save() {
      if (this.groupName.length == 0) {
        this.alert("error", "Nhập tên nhóm.");
        return;
      }
      if (this.items.length < 2) {
        this.alert("error", "Chọn ít nhất 02 người bạn.");
        return;
      }
      let body = {
        groupName: this.groupName,
        accountId: this.accountId,
        membersId: this.getMembersId()
      };
      this.$http.post("/api/conversation/createGroup", body).then((resp) => {
        this.close();
        if (resp.data.error_code === 270) {
          return this.alert("error", "Bạn đã đạt giới hạn tạo nhóm trong ngày.");
        }
        this.alert("success", "Tạo nhóm thành công");
      });
    },
    searchContact() {
      if (this.searchKey.length > 0) {
        this.contactView = this.contactList.filter(p => p.displayName.toLowerCase().includes(this.searchKey.toLowerCase()));
      } else {
        this.contactView = this.contactList;
      }
    },

    unSelect(contactId) {
      let filter = this.items.filter((con) => con.id == contactId);
      if (filter != null && filter.length > 0) {
        const index = this.items.indexOf(filter[0]);
        if (index > -1) {
          this.items.splice(index, 1);
        }
      }
    },
    selectItem(contact) {
      let filter = this.items.filter((con) => con.id == contact.id);
      if (filter != null && filter.length > 0) {
        const index = this.items.indexOf(filter[0]);
        if (index > -1) {
          this.items.splice(index, 1);
        }
      } else {
        this.items.push(contact);
      }
    },
    checkSelectedContact(id) {
      let filter = this.items.filter((con) => con.uid == id);
      if (filter != null && filter.length > 0) {
        return true;
      }
      return false;
    },
    getAllContact() {
      this.$http
        .get("/api/contact/filter", {
          params: {
            searchKey: "",
            accountId: this.accountId,
            page: 0,
            pageSize: 10000
          }
        })
        .then(resp => {
          this.contactList = resp.data.content;
          if (this.userId) {
            let filter = this.contactList.filter((con) => con.uid == this.userId);
            if (filter != null && filter.length > 0) {
              this.items.push(filter[0]);
            }
          }
          this.searchContact();
        });
    },
    setAccountId(id) {
      this.accountId = id;
      this.getAllContact();
    },

    close() {
      this.$bus.$emit("closeCreateGrMsg", null);
      this.$emit("close", null);
    }
  }


};
</script>

<style scoped>

</style>